import { io } from 'socket.io-client';
import store from '@/store'
import { parseNode, consoleDebug, consoleError } from '@/helpers';
import EventBus from '@/event-bus';
// import { useToast } from "primevue/usetoast";
// const VUE_APP_SOCKET_ENDPOINT = 'http://localhost:3000';
// const VUE_APP_SOCKET_ENDPOINT_FALLBACK = 'http://192.168.88.11:3000';

let _system_log = [];

class SocketioService {
	socket;
	timer;
	alarmTimer;
	responeTimeout = 10000;
	alarmInterval = 10000;
	retryCount = 0;

	constructor() {

	}

	responeTimeoutCalc() {
		const timeout = store.getters.getAppSetup.responseTimeout;
		if (timeout && typeof(timeout) === "number" ) {
			return timeout*1000;
		}
		return this.responeTimeout;
	}
	alarmIntervalCalc() {
		const interval = store.getters.getAppSetup.alarmInterval;
		if (interval && typeof(interval) === "number" ) {
			consoleDebug('interval:', interval);
			return interval*1000;
		}
		consoleDebug('interval:', this.alarmInterval);
		return this.alarmInterval;
	}

	async setupSocketConnection(host, port, protocol) {
		// this.connectionTimer();
		if (process.env.VUE_APP_LOCALDEV === "true") {
			let path = '/'
			let url;
			port = 3001;
	
			// Socket.io base connection address same host as webapp but port 3000
			url = protocol + "//" + host + ":" + port + path;
			consoleDebug("[SOCKETIO] LOCAL DEV URL: ", url);
	
			this.socket = io(url, {
				auth: {
					// token: `Bearer ${localStorage.getItem('token')}`
					token: `Bearer ${localStorage.getItem('token')}`
				}
			});
			if (this.socket) return this.socket;
		} else {
			const url = `${protocol}//${host}:${port}`;
			//url = protocol + "//" + host + path;
			//url = 'https:' + "//" + host;
			//const kaka = port + protocol + path;
			//consoleDebug(kaka);
			
			consoleDebug("SOCKETIO URL: ", url);
			const jwtToken = localStorage.getItem('token');
			consoleDebug("JWTTOKEN: ", jwtToken);
			//url = '/enatsrv/';
			this.socket = io(url, {
				path: '/enatsrv/socket.io',
				cors: {
					origin: '*',
				},
				auth: {
					//token: `Bearer ${localStorage.getItem('token')}`
					token: `Bearer ${jwtToken}`
				},
				//transports: ["websocket"]
			});
			if (this.socket) return this.socket;
		}

		
		// register Socket events
		this.removeListeners();
		// this.sockEventEssential();
		// this.sockEventConnection();
		// this.sockEventExtended();
		//this.sockEventValues();

		// request initial states
		// this.sockRequestEssential();
		this.init();
	}
	init() {
		// Handle disconnections
		this.socket.on('disconnect', () => {
			this.disconnect();
		});
	}
	getSocket() {
		return this.socket;
	}
	disconnect() {
		if (this.socket) {
			consoleDebug(`[SOCKETIO] disconnect event for ${this.socket.id}`);
			this.socket.removeAllListeners();
			this.socket.emit('byebye', this.socket.id);
			this.socket.disconnect();
			// store.dispatch("setGlobalLoader", { loading: true, init: true, title: 'Verbindung unterbrochen' });
		}
		this.stopAlarmFetchInterval();
	}
	removeListeners() {
		if (this.socket) {
			this.socket.removeAllListeners();
			consoleDebug('Socket Event Listeners removed');
			// this.sockEventEssential();
		}
	}
	addEventListener(event) {
		if (this.socket) {
			this.socket.on(event.type, event.callback);
		}
	}
	removeEventListener(event) {
		if (this.socket) {
			this.socket.removeAllListeners(event.type);
		}
	}
	renewSocketToken(token) {
		if (this.socket && token) {
			const auth = { token: `Bearer ${token}` };
      this.socket.auth = auth;
			consoleDebug(`[SOCKETIO] auth token renewed: ${token}`);
		}
	}
	connectionTimerReset() {
		this.disconnect();
		clearTimeout(this.timer);
		this.timer = null;
		consoleDebug(`[LOGOUT] <SOCKETIOSERVICE> connection timer reset`);
	}
	connectionTimer() {
		if (this.responeTimeoutCalc() > 0) {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				store.dispatch("setSystemStatus", "offline");
				// store.dispatch("setLoader", { type: 'socketio', loading: true });
				this.retryCount += 1;
				store.dispatch("setGlobalLoader", { loading: true, init: false, title: `Verbindung verloren. ${this.retryCount}. Versuch` });
				clearTimeout(this.timer);
				this.disconnect();
				store.dispatch("startSocketIo", null);
				// store.dispatch("startSocketIo", null).then(() => { 
				// 	consoleDebug(`[INIT] <SOCKETIOSERVICE> all done`);
				// 	// store.dispatch("setLoader", { type: 'socketio', loading: false });
				// 	// store.dispatch("setGlobalLoader", { loading: false, init: true, title: '' });
				// 	EventBus.emit('doneLoading');
				// 	consoleDebug(`[INIT] <SOCKETIOSERVICE> initial connection phase done!`);
				// });
				this.connectionTimer();
			},
			this.responeTimeoutCalc());
		}
	}
	sockEventEssential(callback) {
		// this.socket.on('dateTime', (data) => {
		// 	const _msg = "System online";
		// 	// consoleDebug(data);
		// 	// _system_log = data;
		// 	clearTimeout(this.timer);
		// 	// this.connectionTimer();
		// 	callback(_msg, data.dateTime);
		// 	// store.dispatch("setSystemStatus", _msg);
		// 	// store.dispatch("setDateTime", data.dateTime);
		// });

		// consoleDebug(localStorage.getItem('token'));
		
		this.socket.on('heartbeat1', (data) => {
			// const _msg = "System online";
			// consoleDebug(data);
			callback(null, data);
			// _system_log = data;
			// clearTimeout(this.timer);
			// this.connectionTimer();
			// callback(_msg, data.dateTime);
			// store.dispatch("setSystemStatus", _msg);
			// store.dispatch("setDateTime", data.dateTime);
		});
	}
	registerConnectionEvent(callback) {
		// this.socket.on('connect', (data) => {
		// 	consoleDebug(`[SOCKETIO] connection ${data}`);
		// 	callback(data);
		// });
		callback();
		
	}
	socketEventValue(callback) {
		this.socket.on('valueEvent2', (vars) => {
			// vars.forEach((element) => {
			// 		// store.dispatch('setValues', element.data);
			// });
			callback(vars);
		});
	}
	socketEventUuid(callback) {
		this.socket.on('uuidEvent', (vars) => {
			// vars.forEach((element) => {
			// 		// store.dispatch('setValues', element.data);
			// });
			callback(vars);
		});
	}
	async sendEvent(event, callback) {
		if (this.socket) {
			await new Promise(resolve => {
				this.socket.emit(event.type, event.data, (response) => {
					resolve(callback(response));
				});
			});
			
		}
	}

	socketEventConnection(callback) {
		this.socket.on('connect', () => {
			store.dispatch('setSocketIo', this.socket);
			this.socket.emit('iAmReady', localStorage.getItem('token'));
			this.listenToHeartbeat();
			this.listenToOpcuaEvents();
			this.startAlarmFetchInterval();
			EventBus.emit('socketIoConnected');
			callback('>>> Socket connection established!')
			// consoleDebug('>>> Socket connection established!');
		});

		this.socket.on('tokenRenewal', (data) => {
			store.dispatch('auth/loadNewToken', data);
		});

		this.socket.on('reconnect', () => {
			callback('>>> Socket connection re-established!')
			// consoleDebug('Socket connection re-established!');
		});

		
	}

	socketEventConnectionError(callback) {
		this.socket.on('connect_error', (data) => {
			consoleError(`[SOCKETIO] connect error: ${data}`);
			callback(data);
		});
	}
	// async sockEventEssential() {
	// 	await this.socket.on('dateTime', (data) => {
	// 		const _msg = "System online";
	// 		// consoleDebug(data);
	// 		// _system_log = data;
	// 		clearTimeout(this.timer);
	// 		this.connectionTimer();
	// 		store.dispatch("setSystemStatus", _msg);
	// 		store.dispatch("setDateTime", data.dateTime);
	// 	});
	// }
	
	async sockEventExtended() {
		// store.dispatch("loadClientData");
		this.loadClientData();
		await this.socket.on('system_log', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			store.dispatch("setSystemLog", data);
		});

		await this.socket.on('connections', (data) => {
			store.dispatch("setActiveConnections", data);
		});

		// this.socket.on('clientData', (data) => {
		// 	// consoleDebug("CLIENTDATA");
		// 	// consoleDebug(data);
		// 	// _system_log = data;
		// 	store.dispatch("setClientData", data);
		// });

		this.socket.on('alarm_log', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			if (data !== null) {
				let alarmCnt = data.length;
				store.dispatch("setAlarmCount", alarmCnt);
				store.dispatch("setAlarmLog", data);
			}
		});
	}
	async sockEventValues() {
		this.socket.on('valueEvent', (vars) => {
			consoleDebug(vars);
			// store.dispatch('setValues', vars);
		});
		// CURRENT valueEvent RECEIVER!!!
		await new Promise(resolve => {
			this.socket.on('valueEvent2', (vars) => {
				consoleDebug(vars);
				vars.forEach((element) => {
						store.dispatch('setValues', element.data);
				});
				resolve(vars);
			});	
		});
		
		// UUID valueEvent RECEIVER!!!
		await new Promise(resolve => {
			this.socket.on('valueEvent99', (vars) => {
				consoleDebug("UUID: ", vars);
				vars.forEach((element) => {
						store.dispatch('setValues2', element.data);
				});
				resolve(vars);
			});
		});
		
		this.socket.on('alarmEvent', (vars) => {
			consoleDebug(vars);
			// vars.forEach((element) => {
			// 		store.dispatch('setValues', element.data);
			// });
		});
		this.socket.on('alarmList', (vars) => {
			consoleDebug(vars);
			// vars.forEach((element) => {
			// 		store.dispatch('setValues', element.data);
			// });
		});
		this.socket.on('valueEvent33', (vars) => {
			// consoleDebug(vars);
			vars.forEach((element) => {
					store.dispatch('setEventValue', element);
			});
		});
		this.socket.on('tmrValueEvent', (vars) => {
				vars.forEach((element) => {
						store.dispatch('setValues', element);
				});
		});
		consoleDebug(store.getters.getValues);
	}
	async sockRequestEssential() {
		store.dispatch("setLoading", 1);
		if (this.socket) {
			await this.socket.emit('getClientData');
			await this.socket.emit('system', ('log'));
			await this.socket.emit('system', ('alarm_log'));
		}
		store.dispatch("setLoading", -1);
	}

	async loadClientData() {
		store.dispatch('setLoading', 1);
		await this.getServerData("config", "clientData", (err, response) => {
			consoleDebug(response);
			store.dispatch('loadClientData', response);
			store.dispatch('setLoading', -1);
		});
	}
	// load current status io from backend
	async loadStatusIo() {
		await this.getServerData("status", "io", (err, response) => {
			consoleDebug(response);
			store.dispatch('loadStatusIo', response);
		});
	}
	// load current config io from backend
	async loadConfigIo() {
		await this.getServerData("config", "io", (err, response) => {
			store.dispatch('loadConfigIo', response);
		});
	}
	// load IO-Tree list
	async loadIoTree() {
		store.dispatch('setLoading', 1);
		await this.getServerData("config", "ioTreeView", (err, response) => {
			store.dispatch('setIoTree', response);
			store.dispatch('setLoading', -1);
		});
	}
	// reload all relevant data
	reloadAll() {
		consoleDebug("Fetching server data...");
		//this.loadStatusIo();
		this.loadConfigIo();
		this.loadIoTree();
	}

	// connectionTimer() {
	// 	const _msg = "System Offline!";
	// 	consoleDebug('starting timer');
	// 	this.timer = setTimeout(store.dispatch("setSystemStatus", _msg), 3000);
	// }

	
	async getServerData(section, entry, callback) {
		if (this.socket) {
			store.dispatch("setLoading", 1);
			await new Promise(resolve => {
				this.socket.emit(section, entry, (err, response) => {
					// consoleDebug(response);
					store.dispatch("setLoading", -1);
					resolve(callback(err, response));
				});
			});
		}

		
	}
	async setServerData(section, entry, data, callback) {
		if (this.socket) {
			store.dispatch("setLoading", 1);
			const userObj = store.getters['auth/getUser'];
			await this.socket.emit(section, entry, userObj, data, (err, response) => {
				store.dispatch("setLoading", -1);
				// consoleDebug(err, response);
				callback(err, response);
			});
		}
	}


	async getClientData() {
		if (this.socket) {
			await this.socket.emit('getClientData', ('copyright'));
		}
	}
	getSystemLog() {
		if (this.socket) {
			// return new Promise((resolve) => resolve(_system_log));
			return _system_log;
		}
	}
	async getSystemConfigCopyright() {
		if (this.socket) {
			await this.socket.emit('getSystemConfig', ('copyright'));
		}
	}
	async getStatusIO(callback) {
		if (this.socket) {
			await this.socket.emit('status', ('io'));
		}
		this.socket.on('status_io', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			if (data !== null) {
				callback(data);
			}
		});
	}
	async getStatusIOTree(callback) {
		if (this.socket) {
			await this.socket.emit('status', ('ioTreeView'));
		}
		this.socket.on('status_io_treeview', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			if (data !== null) {
				callback(data);
			}
		});
	}
	async getSingleValue(_id, callback) {
		if (this.socket) {
			await this.socket.emit('getSingleValue', (_id));
		}
		this.socket.on('single_value', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			if (data !== null) {
				callback(data);
			}
		});
	}
	async removeValue(_id) {
		if (this.socket) {
			await this.socket.emit('remove_status_io', (_id));
		}
	}
	async getConfigIO(callback) {
		if (this.socket) {
			await this.socket.emit('config', ('io'));
		}
		this.socket.on('config_io', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			if (data !== null) {
				callback(data);
			}
		});
	}
	// async getViewMenu(callback) {
	// 	if (this.socket) {
	// 		await new Promise(resolve => {
	// 			this.socket.emit('view', 'menu', (response) => {
	// 				consoleDebug(response);
	// 				resolve(callback(response));
	// 			});
	// 		});
	// 		// this.socket.emit('view', ('menu'), (response) => {
	// 		// 	consoleDebug(response);
	// 		// 	callback(response);
	// 		// });
	// 	}
	// 	// this.socket.on('view_menu', (data) => {
	// 	// 	consoleDebug(data);
	// 	// 	// _system_log = data;
	// 	// 	if (data !== null) {
	// 	// 		callback(data);
	// 	// 	}
	// 	// });
	// }

	// (2023) save heartbeat object
	listenToHeartbeat() {
		consoleDebug(`[SOCKETIO] register heartbeat`);
		this.socket.on('heartbeat', (data) => {
			// const loader = store.getters.getGlobalLoader;
			this.retryCount = 0;
			// console.log("[HEARTBEAT] ", data);
			store.dispatch('socket/saveHeartbeat', data);
			this.connectionTimer();
			store.dispatch("setSystemStatus", "online");
		});
	}
	cancelHeartbeat() {
		this.socket.off('heartbeat');
	}
	// (2023) incoming value events from opcua server
	listenToOpcuaEvents() {
		this.socket.on('opcua.events.value', (data) => {
			// store.dispatch('socket/saveHeartbeat', data);
			// this.connectionTimer();
			// store.dispatch("setSystemStatus", "online");
			// consoleDebug(data);
			if (Array.isArray(data) && data.length > 0) {
				store.dispatch('opcua/setNodes', data);
			}
		});

		this.socket.on('opcua.events.alarm', (data) => {
			// store.dispatch('socket/saveHeartbeat', data);
			// this.connectionTimer();
			// store.dispatch("setSystemStatus", "online");
			// consoleDebug(data);
			// if (Array.isArray(data) && data.length > 0) {
			// 	// store.dispatch('opcua/setNodes', data);
				
			// }
			consoleDebug('[SOCKETIO] ALARM EVENT INCOMING!');
			// consoleDebug(data);
				store.dispatch('opcua/setAlarm', data);
		});
	}
	cancelOpcuaEvents() {
		this.socket.off('opcua.events.value');
	}
	// (2023) fetch alarm list with interval
	startAlarmFetchInterval() {
		if (this.alarmIntervalCalc() > 0) {
			consoleDebug(`[APP-SETUP] starting alarm interval with ${this.alarmIntervalCalc()}`);
			this.alarmTimer = setInterval(() => {
				store.dispatch('opcua/loadAlarms', null);
			},
				this.alarmIntervalCalc());
		}
	}
	stopAlarmFetchInterval() {
		consoleDebug(`[APP-SETUP] stopping alarm interval`);
		clearInterval(this.alarmTimer);
		this.alarmTimer = null;
	}
	
	// (2023) get system installation mongodb
	async getSystemInstallation(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "systemConfig",
					query: { 'name': 'installation' }
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getSystemInstallation:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getSystemInstallation`, err);
			callback(err);
		}
	}
	// (2023) set system installation mongodb
	async setSystemInstallation(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'installation';
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "systemConfig",
					query: query,
					payload: { 
						client: { ...data.client },
						location: { ...data.location },
						system: { ...data.system }
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setSystemInstallation:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setSystemInstallation`, err);
			callback(err);
		}
	}
	// (2023) get system copyright mongodb
	async getSystemCopyright(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "systemConfig",
					query: { 'name': 'copyright' }
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getSystemCopyright:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getSystemCopyright`, err);
			callback(err);
		}
	}
	// (2023) set system copyright mongodb
	async setSystemCopyright(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			} else {
				query.name = 'copyright';
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "systemConfig",
					query: query,
					payload: data.payload
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setSystemCopyright:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setSystemApp`, err);
			callback(err);
		}
	}
	// (2023) get system network mongodb
	async getSystemNetwork(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "systemConfig",
					query: { 'name': 'network' }
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getSystemNetwork:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getSystemNetwork`, err);
			callback(err);
		}
	}
	// (2023) set system network mongodb
	async setSystemNetwork(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'network';
			}

			let payload = {};
			if (data.addresses) payload.addresses = { ...data.addresses };
			if (data.notifications) payload.notifications = { ...data.notifications };
			if (data.influxdb) payload.influxdb = { ...data.influxdb };
			if (data.enatsrv) payload.enatsrv = { ...data.enatsrv };			
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "systemConfig",
					query: query,
					payload: { ... payload }
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setSystemNetwork:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setSystemInstallation`, err);
			callback(err);
		}
	}
	// (2023) get system app mongodb
	async getSystemApp(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "systemConfig",
					query: { 'name': 'app' }
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getSystemApp:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getSystemApp`, err);
			callback(err);
		}
	}
	// (2023) set system app mongodb
	async setSystemApp(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			} else {
				query.name = 'app';
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "systemConfig",
					query: query,
					payload: {
						standbyTimeout: data.standbyTimeout,
						responseTimeout: data.responseTimeout,
						alarmInterval: data.alarmInterval,
						discordLink: data.discordLink,
						youtubeLink: data.youtubeLink,
						dropboxLink: data.dropboxLink,
						useGeoSphere: data.useGeoSphere,
						useWeatherStats: data.useWeatherStats
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setSystemApp:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setSystemApp`, err);
			callback(err);
		}
	}
	// (2023) get menu mongodb
	async getViewMenu(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "viewMenu",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getViewMenu:`, response);
					callback(null, response.sort((a, b) => a.index - b.index));
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getViewMenu`, err);
			callback(err);
		}
	}
	// (2023) set view menu mongodb
	async setViewMenu(data, callback) {
		try {
			let query = {};
			let items = null;
			if (data._id) {
				query._id = data._id
			}
			if (data.items) {
				items = [ ...data.items ];
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "viewMenu",
					query: query,
					payload: {
						label: data.label,
						category: data.category,
						icon: data.icon,
						desc: data.desc,
						to: data.to,
						root: data.root,
						parent: data.parent,
						index: data.index,
						items: items
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setViewMenu:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setViewMenu`, err);
			callback(err);
		}
	}
	// (2023) set view menu (array) mongodb
	async setViewMenuArray(data, callback) {
		try {
			let query = {};
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "viewMenu",
					query: query,
					payload: [ ...data ]
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setViewMenuArray:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setViewMenuArray`, err);
			callback(err);
		}
	}
	// (2023) del view menu mongodb
	async delViewMenu(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}
			
			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "viewMenu",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delViewMenu:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delViewMenu`, err);
			callback(err);
		}
	}
	// (2023) get view page mongodb
	async getViewPage(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "viewPage",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getViewPage:`, response);
					callback(null, response.sort((a, b) => a.index - b.index));
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getViewPage`, err);
			callback(err);
		}
	}
	// (2023) set view page mongodb
	async setViewPage(data, callback) {
		try {
			let query = {};
			let components = null;
			if (data._id) {
				query._id = data._id
			}
			if (data.components) {
				components = [ ...data.components ];
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "viewPage",
					query: query,
					payload: {
						label: data.label,
						content: data.content,
						key: data.key,
						type: data.type,
						name: data.name,
						style: data.style,
						components: components
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setViewPage (${data.label}):`, response);
						callback(null, response, data);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setViewPage`, err);
			callback(err);
		}
	}
	// (2023) del view page mongodb
	async delViewPage(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}
			
			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "viewPage",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delViewPage:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delViewPage`, err);
			callback(err);
		}
	}
	// (2023) get view page entry mongodb
	async getViewPageEntry(id, callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "getOne",
				data: {
					collectionName: "viewPage",
					query: { name: id}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getViewPageEntry:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getViewPageEntry`, err);
			callback(err);
		}
	}
	// (2023) get module types mongodb
	async getUnitTypes(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleTypes",
					query: { name: 'unitTypes'}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getUnitTypes:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getUnitTypes`, err);
			callback(err);
		}
	}
	// (2023) set unit types mongodb
	async setUnitTypes(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'unitTypes';
			}
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "moduleTypes",
					query: query,
					payload: { 
						children: [ ...data.data ]
					}
				}
			}

			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setUnitTypes:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setUnitTypes`, err);
			callback(err);
		}
	}
	// (2023) get module types mongodb
	async getCategoryTypes(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleTypes",
					query: { name: 'categoryTypes'}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getCategoryTypes:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getCategoryTypes`, err);
			callback(err);
		}
	}
	// (2023) get module types mongodb
	async setCategoryTypes(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'categoryTypes';
			}
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "moduleTypes",
					query: query,
					payload: { 
						children: [ ...data.data ]
					}
				}
			}

			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setCategoryTypes:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setCategoryTypes`, err);
			callback(err);
		}
	}
	// (2023) get module types mongodb
	async getDepartmentTypes(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleTypes",
					query: { name: 'departmentTypes'}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getDepartmentTypes:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getDepartmentTypes`, err);
			callback(err);
		}
	}
	// (2023) set department types mongodb
	async setDepartmentTypes(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'departmentTypes';
			}
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "moduleTypes",
					query: query,
					payload: { 
						children: [ ...data.data ]
					}
				}
			}

			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setDepartmentTypes:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setDepartmentTypes`, err);
			callback(err);
		}
	}
	// (2023) get module types mongodb
	async getIconTypes(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleTypes",
					query: { name: 'iconTypes'}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getIconTypes:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getIconTypes`, err);
			callback(err);
		}
	}
	// (2023) set icon types mongodb
	async setIconTypes(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'iconTypes';
			}
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "moduleTypes",
					query: query,
					payload: { 
						children: [ ...data.data ]
					}
				}
			}

			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setDepartmentTypes:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setDepartmentTypes`, err);
			callback(err);
		}
	}
	// (2023) get opc servers mongodb
	async getOpcuaServers(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "configOpc",
					query: { name: 'server'}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getOpcuaServers:`, response);
					callback(null, response[0]);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getOpcuaServers`, err);
			callback(err);
		}
	}
	// (2023) set opc servers mongodb
	async setOpcuaServers(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id;
			} else {
				query.name = 'opcServerList';
			}
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "configOpc",
					query: query,
					payload: { 
						children: [ ...data.data ]
					}
				}
			}

			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setOpcuaServers:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setDepartmentTypes`, err);
			callback(err);
		}
	}
	// (2023) get change log mongodb
	async getChangeLog(options, query, callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "logChange",
					query: query,
					options: options
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getChangeLog:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getChangeLog`, err);
			callback(err);
		}
	}
	// (2023) delete change log mongodb
	async delChangeLog(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}

			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "logChange",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delChangeLog:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delChangeLog`, err);
			callback(err);
		}
	}
	// (2023) get alarm log mongodb
	async getAlarmLog(options, query, callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "logAlarm",
					query: query,
					options: options
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getAlarmLog:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getAlarmLog`, err);
			callback(err);
		}
	}
	// (2023) delete alarm log mongodb
	async delAlarmLog(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}

			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "logAlarm",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delAlarmLog:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delAlarmLog`, err);
			callback(err);
		}
	}
	// (2023) get one user mongodb
	async getUser(username, callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "getOne",
				data: {
					collectionName: "userList",
					query: { username: username }
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getUser:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getUser`, err);
			callback(err);
		}
	}
	// (2023) get user list mongodb
	async getUserList(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "userList",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getUserList:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getUserList`, err);
			callback(err);
		}
	}
	// (2023) set user list mongodb
	async setUserList(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "userList",
					query: query,
					payload: {
						active: data.active,
						fullname: data.fullname,
						role: data.role,
						username: data.username,
						notifications: data.notifications,
						config: data.config
					}
				}
			}
			if (data.newPassword) {
				request.data.payload.password = data.newPassword;
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] getUserList:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setUserList`, err);
			callback(err);
		}
	}
	// (2023) del user mongodb
	async delUser(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}
			
			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "userList",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delUser:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delUser`, err);
			callback(err);
		}
	}
	// (2023) get user group mongodb
	async getUserGroupList(callback) {
		try {
			const request = {
				"type": "mongodb",
				"cmd": "get",
				"data": {
					"collectionName": "userGroup",
					"query": {}
				}
			}
			this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getUserGroup:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getUserList`, err);
			callback(err);
		}
	}
	// (2023) del user group mongodb
	async delUserGroup(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}
			
			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "userGroup",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delUserGroup:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delUserGroup`, err);
			callback(err);
		}
	}
	// (2023) get modules mongodb
	async getModules(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "modules",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getModules:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getModules`, err);
			callback(err);
		}
	}
	// (2023) set modules mongodb
	async setModules(data, callback) {
		try {
			let query = {};
			let source = null;
			let metadata = null;
			let bindings = null;
			let permissions = null;
			if (data._id) {
				query._id = data._id
			}
			if (data.source) source = { ...data.source };
			if (data.metadata) metadata = { ...data.metadata };
			if (data.bindings) bindings = { ...data.bindings };
			if (data.permissions) permissions = { ...data.permissions };
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "modules",
					query: query,
					payload: {
						moduleName: data.moduleName,
						source: source,
						metadata: metadata,
						bindings: bindings,
						permissions: permissions
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setModules:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setModules`, err);
			callback(err);
		}
	}
	// (2023) delete modules mongodb
	async delModules(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}

			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "modules",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delModules:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delModules`, err);
			callback(err);
		}
	}
	// (2023) get module scheme mongodb
	async getModuleScheme(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleScheme",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getModuleScheme:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getModuleScheme`, err);
			callback(err);
		}
	}
	// (2023) set modules scheme mongodb
	async setModuleScheme(data, callback) {
		try {
			let query = {};
			let key = '';
			let children = [];
			if (data._id) {
				query._id = data._id
			}
			if (data.children) children = [ ...data.children ];
			if (data.key) key = data.key;
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "moduleScheme",
					query: query,
					payload: {
						key: key,
						scheme: data.scheme,
						label: data.label,
						children: children
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setModuleScheme:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setModuleScheme`, err);
			callback(err);
		}
	}
	// (2023) set modules scheme mongodb
	async setModuleSchemeFromTree(data, callback) {
		try {
			let query = {};
			const children = [];
			const key = '';

			for(let i=1; i<data.length; i++) {
				children.push(data[i]);
			}
			
			const request = {
				type: "mongodb",
				cmd: "set",
				data: {
					collectionName: "moduleScheme",
					query: query,
					payload: {
						key: key,
						scheme: data[0].scheme,
						label: data[0].label,
						children: children
					}
				}
			}
			if (this.socket && data) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setModuleScheme:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setModuleScheme`, err);
			callback(err);
		}
	}
	// (2023) delete module scheme mongodb
	async delModuleScheme(data, callback) {
		try {
			let query = {};
			if (data._id) {
				query._id = data._id
			}

			const request = {
				type: "mongodb",
				cmd: "del",
				data: {
					collectionName: "moduleScheme",
					query: query
				}
			}
			if (this.socket && query._id) {
				consoleDebug('request: ', request);
				await this.socket.emit('frontendDataRequest', request, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] delModuleScheme:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] delModuleScheme`, err);
			callback(err);
		}
	}
	// (2023) get module bindings mongodb
	async getModuleBindings(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleBindings",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getModuleBindings:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getModuleBindings`, err);
			callback(err);
		}
	}
	// (2023) get module types mongodb
	async getModuleTypes(callback) {
		try {
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "moduleTypes",
					query: {}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getModuleTypes:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getModuleTypes`, err);
			callback(err);
		}
	}
	// (2023) get opcua browse
	async getOpcuaBrowse(server, callback) {
		try {
			let query = {
				type: 'opcServerTree'
			};
			if (server) {
				query.id = server;
			}
			
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "configOpc",
					query: query
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getOpcuaBrowse:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getOpcuaBrowse`, err);
			callback(err);
		}
	}
	// (2024) get opcuatree browse
	async getOpcuaTreeBrowse(server, callback) {
		try {
			let query = {};
			if (server) {
				query.server = server;
			}
			
			const request = {
				type: "mongodb",
				cmd: "get",
				data: {
					collectionName: "configOpcTree",
					query: query
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getOpcuaTreeBrowse:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getOpcuaTreeBrowse`, err);
			callback(err);
		}
	}
	// (2023) get opcua value
	async getOpcuaValue(server, identifier, callback) {
		try {
			const request = {
				type: "opcua",
				cmd: "get",
				data: {
					funct: "value",
					server: server,
					identifier: identifier
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getOpcuaValue:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getOpcuaValue`, err);
			callback(err);
		}
	}
	// (2023) get redis hash
	async getRedisHash(hash, callback) {
		try {
			const request = {
				type: "redis",
				cmd: "get",
				data: {
					funct: "hash",
					hash: hash
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getRedisHash:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getRedisHash`, err);
			callback(err);
		}
	}
	// (2023) get redis nodes
	async getRedisNodes(hash, callback) {
		try {
			const request = {
				type: "redis",
				cmd: "get",
				data: {
					funct: "nodes",
					hash: hash
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getRedisNodes:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getRedisNodes`, err);
			callback(err);
		}
	}
	// (2023) get redis nodes and parameter in array
	async getRedisNodesParam(hash, callback) {
		try {
			const request = {
				type: "redis",
				cmd: "get",
				data: {
					funct: "nodesParam",
					hash: hash
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getRedisNodesParam (${hash}):`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO][ERR] getRedisNodesParam (${hash})`, err);
			callback(err);
		}
	}
	// (2023) get redis nodes and parameter in array
	async getRedisNodesParamScaled(hash, callback) {
		try {
			const request = {
				type: "redis",
				cmd: "get",
				data: {
					funct: "nodesParam",
					hash: hash
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getRedisNodesParamScaled:`, response);
					const result = [];
					if (response) {
						response.forEach((entry) => {
								const newObj = parseNode(entry);
								result.push(newObj);
						});
						callback(null, result);
					} else {
						callback(null, null);
					}
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getRedisNodesParamScaled`, err);
			callback(err);
		}
	}
	// (2023) set/write opc value(s)
	async setOpcValue(data, callback) {
		try {
			if (this.socket && data) {
				consoleDebug('[SOCKETIO] request: ', data);
				await this.socket.emit('opcuaWriteValue', data, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] setOpcValue:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] setOpcValue`, err);
			callback(err);
		}
	}
	// (2024) run server command
	async runServerCmd(cmd, callback) {
		try {
			if (this.socket && cmd) {
				let data = {};
				data.cmd = cmd;
				consoleDebug('[SOCKETIO] request: ', data);
				await this.socket.emit('runSystemCmd', data, (err, response) => {
					if (err) {
						throw err;
					} else {
						consoleDebug(`[SOCKETIO] runSystemCmd:`, response);
						callback(null, response);
					}
				});
			}
		} catch (err) {
			consoleError(`[SOCKETIO] runSystemCmd`, err);
			callback(err);
		}
	}
	// (2023) get modules mongodb
	async getChart2(data, callback) {
		// const pipeline = [
		// 	{
		// 		$match: {
		// 			$and: [
		// 				// { "timestamp": { $gte: new Date(data.startTime) } },
		// 				// { "timestamp": { $lte: new Date(data.endTime) } },
		// 				{ "timestamp": { $gte: new Date(Date.now() - (23 * 60 * 60 * 1000)) } },
		// 				{ "timestamp": { $lte: new Date(Date.now()) } },
		// 				{ "hash": data.hash }
		// 			]
		// 		}
		// 	},
		// 	{
		// 		$group: {
		// 			_id: {
		// 				// $dateToString: { format: "%Y-%m-%dT%H", date: "$timestamp" }
		// 				$dateToString: { date: "$timestamp", format: "%d.%m.%Y - %H:00h", timezone: "Europe/Vienna" }
		// 			},
		// 			value: { $first: "$value" },
		// 		}
		// 	},
		// 	{
		// 		$sort: {
		// 			"_id": 1
		// 		}
		// 	}
		// 	]

		try {
			if (!data.cumulative) data.cumulative = false;
			const request = {
				type: "mongodb",
				cmd: "getChart",
				data: {
					collectionName: "record",
					node: {
						hash: data.hash,
						startTime: data.startTime,
						endTime: data.endTime,
						format: data.format,
						cumulative: data.cumulative
					}
				}
			}
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getChart:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getChart`, err);
			callback(err);
		}
	}

	// (2023) get modules mongodb
	async getChart(data, callback) {
		try {
			if (!data.cumulative) data.cumulative = false;
			const request = {
				type: "influxdb",
				cmd: "getChart",
				data: {
					collectionName: "record",
					node: {
						hash: data.hash,
						server: data.server,
						identifier: data.identifier,
						startTime: data.startTime,
						endTime: data.endTime,
						format: data.format,
						window: data.window,
						cumulative: data.cumulative
					}
				}
			}
			consoleDebug(request);
			await this.getServerData('frontendDataRequest', request, (err, response) => {
				if (err) {
					throw err;
				} else {
					consoleDebug(`[SOCKETIO] getChart:`, response);
					callback(null, response);
				}
			});
		} catch (err) {
			consoleError(`[SOCKETIO] getChart`, err);
			callback(err);
		}
	}

	async removeUser(_id) {
		if (this.socket) {
			await this.socket.emit('remove_user', (_id));
		}
	}
	async removeDatabaseDocument(section, data, callback) {
		if (this.socket) {
			await this.socket.emit('removeDatabaseDocument', section, data, (response) => {
				consoleDebug(response);
				callback(response);
			});
		}
	}
	async setConfigIO(data) {
		if (this.socket) {
			await this.socket.emit('set_status_io', data);
		}
	}
	async setConfigIOType(data, type) {
		if (this.socket) {
			if (type === "types_category") await this.socket.emit('set_config_io_types_category', data);
			if (type === "types_department") await this.socket.emit('set_config_io_types_department', data);
			if (type === "types_io") await this.socket.emit('set_config_io_types_io', data);
			if (type === "types_unit") await this.socket.emit('set_config_io_types_unit', data);
			if (type === "types_server") await this.socket.emit('set_config_io_types_server', data);
			if (type === "types_parameters") await this.socket.emit('set_config_io_types_parameters', data);
			if (type === "types_icons") await this.socket.emit('set_config_io_types_icons', data);
		}
	}
	async getOpcBrowse(callback) {
		if (this.socket) {
			await this.socket.emit('opc', ('browse'));
		}
		this.socket.on('opc_browse', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			callback(data);
		});
	}
	async getOPCAppTree(callback) {
		if (this.socket) {
			await this.socket.emit('opc', ('appTreeView'));
		}
		this.socket.on('opc_app_treeview', (data) => {
			// consoleDebug(data);
			// _system_log = data;
			if (data !== null) {
				callback(data);
			}
		});
	}
	async sendMail(data) {
		if (this.socket) {
			await this.socket.emit('sendMail', data);
		}
	}
	async sendPush(data) {
		if (this.socket) {
			await this.socket.emit('sendPush', data);
		}
	}
}

export default new SocketioService()